module.exports = __webpack_public_path__ + "static/background-3c1321af21bdaa46e272e69fb76662a4.jpg";